<template>
    <article class="empty-list">
        <p
            class="empty-list__text"
            v-html="text"></p>
        <a
            class="empty-list__btn"
            href="#"
            @click.prevent="$emit('btnClick')"
            v-html="btnText"></a>
    </article>
</template>

<script>
    export default {
        name: 'EmptyList',
        props: {
            text: {
                type: String,
                default: ''
            },
            btnText: {
                type: String,
                default: ''
            }
        }
    }
</script>